// ChatInterface.js

import React, { useState, useEffect } from 'react';
import './ChatInterfaceFinal.css';
import { TiMicrophone } from "react-icons/ti";
import { IoMicOff } from "react-icons/io5";
import { FaPaperPlane } from "react-icons/fa";
import Footer from '../reusableComponents/footer';

const formJson = {
  FormName: "Facility",
  Operation: "Create New",
  fields: [
    { field_name: "facility_name", required: true, type: "varchar", min: 3, max: 50, description: "a name of a facility owned by the company" },
    { field_name: "facility_description", required: false, type: "varchar", min: 0, max: 250, description: "a brief description about the facility" },
    { field_name: "state", required: true, type: "varchar", min: 3, max: 50, allowed_values: "all states in India", description: "a state name in India" },
    { field_name: "city", required: true, type: "varchar", min: 3, max: 50, valid_values: "all airport cities in India", description: "a city name in India with a major airport" },
    { field_name: "capacity", required: true, type: "float", min: 1.0, max: 1000000.00, description: "The area of the facility in Square foot area" },
    { field_name: "eb_rate", required: true, type: "float", min: 1.0, max: 200.00, description: "electricity board utility rate per k/wh" },
    { field_name: "water_rate", required: true, type: "float", min: 1.0, max: 200.00, description: "water utility rate per liter" },
    { field_name: "dg_rate", required: true, type: "float", min: 0.0, max: 200.00, description: "diesel generator rate per k/wh" }
  ]
};



const ChatInterface = () => {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const [recognition, setRecognition] = useState(null);
  const [facilityData, setFacilityData] = useState({
    facility_name: "",
    facility_description: "",
    state: "",
    city: "",
    space_capacity:"",
    eb_rate: "",
    water_rate: "",
    dg_rate: ""
}); // To store facility data


  const speak = (text) => {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'en-US'; // Set the language
      speechSynthesis.speak(utterance); // Speak the text
    };

    const [showMic, setShowMic] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show the arrow when the scroll position is beyond 100px from the top
      if (window.scrollY > 120) {
        setShowMic(true);
      } else {
        setShowMic(false);
      }
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
      
  useEffect(() => {
   
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const newRecognition = new SpeechRecognition();
    newRecognition.interimResults = true;
    newRecognition.lang = 'en-US';
    setRecognition(newRecognition);

    newRecognition.onresult = (event) => {
      const currentTranscript = event.results[event.resultIndex][0].transcript;
      setUserInput(currentTranscript);
    };

    newRecognition.onend = () => {
      setIsRecording(false);
    };
    speakInitialMessage();
    return () => {
      newRecognition.stop();
    };
  }, []);

  const speakInitialMessage = () => {
     // Greeting message and prompt for information
     speak("Hello, I am here to help you create a new facility! Please say the facility name, description, state, city, space capacity, eb rate, water rate, dg rate. Start speaking...");
     // let promptMessage = "Hello, I am here to help you create a new facility! Please provide the facility information such as facility name, facility description, state, city, area, eb_rate, water_rate, dg_rate.";
     // setMessages(prevMessages => [...prevMessages, { text: promptMessage, sender: 'ui' }]);
     // speak(promptMessage);
     // Initialize speech recognition
  }



  const handleSendMessage = async (e) => {
    scrollToSection('fieldDetails');
    e.preventDefault();
    if (userInput.trim() === '') return;

    // Add user's message to the chat
    setMessages([...messages, { text: userInput, sender: 'user' }]);
    // speak(userInput); // Speak the user's input
    // await processUserInput(userInput); // Process the user's input
    const data123 = await handleChatGPTConvo(userInput);
    
    setFacilityData(JSON.parse(data123));
    generateNextQuestionCustom(JSON.parse(data123));
    setUserInput('');
  };

  const handleChatGPTConvo = async (userInput) => {

    const prompt = `Process this message from the user ${userInput} and evaluate and extract information from the message and fill the json object ${JSON.stringify(facilityData)} and give only the JSON object and no other information.`;


    try {
        const response = await fetch('https://api.openai.com/v1/chat/completions', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer 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`, // Replace with your API key securely
          },
          body: JSON.stringify({
            model: "gpt-3.5-turbo", // Specify the model
            messages: [{ role: "user", content: prompt }], // Send the prompt as a user message
            max_tokens: 150, // Limit the response length
          })
        });
        
        const responseData = await response.json();
        
        // Check for errors in response
        if (response.ok) {
          return responseData.choices[0].message.content; // Extract the response text
        } else {
          console.error("Error in response:", responseData);
          return "I'm having trouble fetching the next question, please provide more information.";
        }
      } catch (error) {
        console.error("Error fetching data from ChatGPT:", error);
        return "I'm having trouble fetching the next question, please provide more information.";
      }


  }

  const generateNextQuestionCustom = async (data) => {
    let missingFields = [];

    for (let key in data) {
        if (data[key] === "") {
            missingFields.push(key);
        }
    }

    if (missingFields.length > 0) {
        let promptMessage = "Please provide values for the following fields:\n";
        missingFields.forEach(field => {
            promptMessage += `- ${field.replace(/_/g, ' ')}\n`;
        });
         // You can replace this with any prompt mechanism
        setMessages(prevMessages => [...prevMessages, { text: promptMessage, sender: 'ui' }]);
        speak(promptMessage);
    } else {
        let promptMessage = "All fields are filled. Unless you want to change any information, Please confirm the information provided below and create a facility.";
        setMessages(prevMessages => [...prevMessages, { text: promptMessage, sender: 'ui' }]);
        speak(promptMessage);
    }

  }

  

  

  const handleRecord = () => {
    if (recognition) {
      if (!isRecording) {
        setIsRecording(true);
        scrollToSection('mainChat');
        window.speechSynthesis.cancel(); // Stop speaking when recording
        recognition.start(); // Start speech recognition
      } else {
        recognition.stop(); // Stop speech recognition
      }
    }
  };



  const scrollToSection = (sectionId) => {
    const targetElement = document.getElementById(sectionId);
    const targetPosition = targetElement.getBoundingClientRect().top; // Position of the section relative to the viewport
    const startPosition = window.pageYOffset; // Starting scroll position
    const distance = targetPosition - startPosition;
    const duration = 1200; // 1200ms = 1.2 seconds for scrolling (adjust to make slower or faster)
    let startTime = null;

    const ease = (t, b, c, d) => {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    };

    const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation); // Continue animation
    };

    requestAnimationFrame(animation);
};
 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFacilityData({
      ...facilityData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    // try {
    //   const response = await fetch('https://your-backend-url.com/api/facility', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     body: JSON.stringify(facilityData)
    //   });
    //   if (response.ok) {
    //     alert('Form submitted successfully!');
    //   } else {
    //     alert('Form submission failed!');
    //   }
    // } catch (error) {
    //   console.error('Error:', error);
    // }

    speak("The facility has successfully been created. Thank you for providing the information.");
    setFacilityData({
      facility_name: "",
      facility_description: "",
      state: "",
      city: "",
      space_capacity:"",
      eb_rate: "",
      water_rate: "",
      dg_rate: ""

    })
    setMessages([]);
    scrollToSection('mainChat');
    speakInitialMessage();
  };

 
  
  return (
    <>
    <div id="mainChat" className="chat-interface">
      {/* <div className="chat-window">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.sender}`}>
            <span>{msg.text}</span>
          </div>
        ))}
      </div> */}
      <div style={{display:"flex", justifyContent:"center", margin:"30px"}}>
        <img src="./images/Turnkey-logo-final_1.png" alt="Turnkey Learning" className="chatbot-img" />
      </div>
      {/* <div style={{height:"200px"}}></div> */}
      <div className='input-form-container'>
        <form className="input-form" onSubmit={handleSendMessage}>
          <textarea 
          className=''
            type="text"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            placeholder={messages.length === 0 ? "Hello, I am here to help you create a new facility! Please say the facility name, description, state, city, space capacity, eb rate, water rate, dg rate. Start speaking..." : messages[messages.length - 1].text}
          />
          <div style={{display:"block", padding:"5px"}}>
            <button type="submit"><FaPaperPlane size="1.5rem"/></button>
            <button className={`mic-btn ${isRecording ? 'recording' : ''}`} type="button" onClick={handleRecord}>
              {isRecording ? <IoMicOff size="1.5rem"/> : <TiMicrophone size="1.5rem"/>}
            </button>
          </div>
          
        </form>
      </div>
      

      
    </div>

    <div id="fieldDetails" className="form-container">
      <h2>Facility Details</h2>
      <form onSubmit={handleSubmit} className="facility-form">
        <div className="form-group-of-3">
          <div className="form-group-big">
            <label>Facility Name: <span style={{color:"red"}}>*</span></label>
            <input 
              type="text" 
              name="facility_name" 
              value={facilityData.facility_name} 
              onChange={handleChange} 
              required 
              className="form-input"
            />
          </div>
          <div className="form-group-big">
          <label>City: <span style={{color:"red"}}>*</span></label>
          <input 
            type="text" 
            name="city" 
            value={facilityData.city} 
            onChange={handleChange} 
            required 
            className="form-input"
          />
        </div>
          
          <div className="form-group-big">
            <label>State: <span style={{color:"red"}}>*</span></label>
            <input 
              type="text" 
              name="state" 
              value={facilityData.state} 
              onChange={handleChange} 
              required 
              className="form-input"
            />
          </div>
        </div>
        <div className="form-group-of-3">
          <div className="form-group-small">
            <label>Space Capacity: <span style={{color:"red"}}>*</span></label>
            <input 
              type="text" 
              name="space_capacity" 
              value={facilityData.space_capacity} 
              onChange={handleChange} 
              required 
              className="form-input"
            />
          </div>
          <div className="form-group-small">
            <label>EB Rate: <span style={{color:"red"}}>*</span></label>
            <input 
              type="text" 
              name="eb_rate" 
              value={facilityData.eb_rate} 
              onChange={handleChange} 
              className="form-input"
            />
          </div>
          <div className="form-group-small">
            <label>Water Rate: <span style={{color:"red"}}>*</span></label>
            <input 
              type="text" 
              name="water_rate" 
              value={facilityData.water_rate} 
              onChange={handleChange} 
              className="form-input"
            />
          </div>
          <div className="form-group-small">
          <label>DG Rate: <span style={{color:"red"}}>*</span></label>
          <input 
            type="text" 
            name="dg_rate" 
            value={facilityData.dg_rate} 
            onChange={handleChange} 
            className="form-input"
          />
        </div>
        </div>
        <div className="form-group-of-3">
        
        <div className="form-group">
            <label>Facility Description:</label>
            <textarea
              name="facility_description"
              value={facilityData.facility_description}
              onChange={handleChange}
              className="form-input"
            />
          </div>
          </div>
        <button type="submit" className="submit-button">Submit</button>
      </form>
    </div>
    {showMic && (
        <div
          style={{
            position: 'fixed',
            right: '20px',
            bottom: '20px',
            cursor: 'pointer',
            fontSize: '24px',
            color: 'white',
            padding: '10px',
            borderRadius: '50%',
            
          }}
        >
            <button className={`mic-btn ${isRecording ? 'recording' : ''}`} type="button" onClick={handleRecord}>
              {isRecording ? <IoMicOff size="1.5rem"/> : <TiMicrophone size="1.5rem"/>}
            </button>
        </div>
      )}

      <Footer />

    </>
  );
};

export default ChatInterface;
